import React from 'react'
import PropTypes from 'prop-types'

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="Footer">
        <div className="inner">
          <div className="Split">
            <div className="Split-left">
              <h1 className="heading-dark">Kennismaken? Meer weten?</h1>
              <p>
                <span className="phone">0252 – 22 25 25</span>
                <span className="divider">|</span>
                <span className="email">info@DeGraaffFinancieeladvies.nl</span>
              </p>
            </div>
            <div className="Main-sidebar Split-right">
              <h3 className="heading-caps">Bezoekadres</h3>
              <p>
                Parklaan 34A,<br />
                2171 EE Sassenheim
              </p>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js